import { render } from "./Vision.vue?vue&type=template&id=1ca011e6"
import script from "./Vision.vue?vue&type=script&lang=js"
export * from "./Vision.vue?vue&type=script&lang=js"

import exportComponent from "/home/soviko/htdocs/soviko.de/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__